// extracted by mini-css-extract-plugin
module.exports = {"points":"Benefit_points__69VJe","pointsGrey":"Benefit_pointsGrey__v5gfr"};